/* G1 chrome (Pergolux P0, 5 Oct 2026). Deferred; loaded right before snippets/woodlit-chat.liquid.
   Modules: office-hours keeper, tel normaliser and tap binder (R02, R09), chat triggers (R09),
   60-Day anchor fallback (R19), float manager (R05), top bar (R19, one message at a time since 16 Oct 2026).
   Each module is guarded so one failure never stops the others. */

/* F5: keep the office-hours state current (the head script set it before first paint). */
(function () {
  try {
    var WL = window.WL;
    if (!WL || typeof WL.applyHours !== 'function') return;
    setInterval(WL.applyHours, 60000);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) WL.applyHours(); });
  } catch (e) {}
})();

/* R09 tel normaliser and R02 tap binder: tel_tap, whatsapp_tap, email_tap with the nearest data-wl-placement. */
(function () {
  try {
    var cleanTel = function (a) {
      var h = a.getAttribute('href') || '';
      if (!/^tel:/i.test(h)) return;
      var raw = h.slice(4);
      try { raw = decodeURIComponent(raw); } catch (e) {}
      var c = raw.replace(/[^\d+]/g, '');
      c = c.charAt(0) + c.slice(1).replace(/\+/g, '');
      if (c && 'tel:' + c !== h) a.setAttribute('href', 'tel:' + c);
    };
    var normAll = function () {
      var n = document.querySelectorAll('a[href^="tel:"], a[href^="TEL:"], a[href^="Tel:"]');
      for (var i = 0; i < n.length; i++) cleanTel(n[i]);
    };
    if (document.readyState !== 'loading') normAll(); else document.addEventListener('DOMContentLoaded', normAll);
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest && e.target.closest('a[href]');
      if (!a) return;
      var h = a.getAttribute('href') || '';
      if (/^tel:/i.test(h)) { cleanTel(a); h = a.getAttribute('href') || ''; }
      if (typeof window.wlTrack !== 'function') return;
      var host = a.closest('[data-wl-placement]');
      var pl = host ? host.getAttribute('data-wl-placement')
        : a.closest('.wl-tb') ? 'topbar' : a.closest('#cart-drawer') ? 'drawer' : a.closest('.cart[data-cart-page]') ? 'cart_page'
        : a.closest('header-drawer') ? 'menu' : a.closest('.footer-sections, footer') ? 'footer' : 'page';
      if (/^tel:/i.test(h)) window.wlTrack('tel_tap', { placement: pl });
      else if (/wa\.me\/|api\.whatsapp\.com|^whatsapp:/i.test(h)) window.wlTrack('whatsapp_tap', { placement: pl });
      else if (/^mailto:/i.test(h)) window.wlTrack('email_tap', { placement: pl });
    }, true);
  } catch (e) {}
})();

/* R09 chat triggers: [data-wl-chat] links open the chat (window.wlOpenChat from woodlit-chat); without it they go to the contact page. */
(function () {
  try {
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest && e.target.closest('[data-wl-chat]');
      if (!t || typeof window.wlOpenChat !== 'function') return;
      e.preventDefault();
      var host = t.closest('[data-wl-placement]'), pl = host ? host.getAttribute('data-wl-placement') : 'page';
      var sheet = t.closest('dialog.wl-cs'); if (sheet && sheet.open) sheet.close();
      var dr = document.querySelector('header-drawer.is-open');
      if (dr) { dr.dispatchEvent(new CustomEvent('theme:drawer:close', { bubbles: true })); setTimeout(function () { window.wlOpenChat(pl); }, 320); }
      else window.wlOpenChat(pl);
    });
  } catch (e) {}
})();

/* R19 60-Day Guarantee anchor fallback on the warranty page (page id gate), until the page body carries the id. */
(function () {
  try {
    var WL = window.WL || {}, ID = 'sixty-day-guarantee';
    if (WL.pageId !== 177743987026) return;
    var go = function () {
      if (location.hash !== '#' + ID || document.getElementById(ID)) return;
      var hs = document.querySelectorAll('.rte h2, .rte h3');
      for (var i = 0; i < hs.length; i++) {
        if (/60/.test(hs[i].textContent || '')) { hs[i].id = ID; hs[i].scrollIntoView(); return; }
      }
    };
    if (document.readyState !== 'loading') go(); else document.addEventListener('DOMContentLoaded', go);
    window.addEventListener('hashchange', go);
  } catch (e) {}
})();

/* R05 float manager: lifts the chat above any visible bottom bar, hides launcher, bubble, teaser and back-to-top
   while a drawer, dialog, photo viewer or the consent banner is open, and yields to [data-wl-avoid-float] controls.
   Fade-ins and fade-outs (Klaviyo popups are inserted at opacity 0 and fade with CSS animations) are followed through
   animation and transition events, a short settle after every DOM insertion, and a light poll while an overlay is open,
   so the state never waits for a scroll (browser QA pass 1, home F2 and collection F1). A dialog that is fading out to
   opacity 0 counts as closed, so the chat and the teaser come back while it fades, as on the live theme.
   Avoid zones (browser QA pass 2, Family Play F1/F2 and cart F1): [data-wl-avoid-float] plus, so the zones hold whatever
   markup the owning groups ship, the fields and buttons of the two Family Play quote forms (PDP #family-quote-form,
   collection #fpc-quote-form) and every block of the /cart summary column (terms, Check out, wallets, help line, bank
   line, marks, notes).
   The launcher fades while it overlaps a zone (html.wl-float-yield) and so does the Klaviyo teaser (html.wl-teaser-yield).
   Round 6 (browser QA pass 3, Kids Play PDP F1 and Family Play F1): a bottom bar lifts the chat from the frame its class
   turns on (layout height, not the faded and translated box, so the launcher no longer waits for the bar's fade-in), and
   keeps the lift while the bar is still on screen fading out and for 250 ms after its class goes off, so a bar that
   flickers off and on does not make the chat jump; the launcher yield also tests the place the launcher is gliding to,
   so it fades before it slides over a zone; the theme back-to-top button yields to the same zones
   (html.wl-btt-yield), measured at its resting place so it never shows over a zone while it slides in.
   Chat icon (13 Oct 2026, owner: "fix the live chat icon"; on phones the launcher covered the right end of the first Kids Play
   card's button at load and card buttons while scrolling): the launcher dodges. Dodge obstacles are the G5 card buttons
   ([data-wl-g5-cta]), any [data-wl-dodge-float] control, and every button and the ink of every text link inside product cards
   (.product-item: grids, rows, related products) and product rows (.index-products), on the homepage and collection templates
   inside all of main (image-only links, summary rows and the avoid zones above are not obstacles; header, pre-footer and footer
   are outside). Only after scrolling has stopped (no finger down and 180 ms
   without a scroll event of the window or of a horizontal row; scrollend is not used, it fires between wheel steps), and after
   load, resize, a bar lift or a settled DOM change, the manager places the launcher: home (bottom 16 + lift) when nothing is
   under it there; else it keeps a lift that is still clear; else the smallest lift (at most 40% of the viewport) that puts it
   10px clear above the obstacles and the avoid zones, set in --wl-float-dodge and glided in one 0.25 s transition (no glide in
   the first 3 s before any scroll). If no lift is clear, it stays home and fades only when a button would be under it
   (html.wl-float-yield). It never moves during a scroll, so a fling through the grid moves it at most once, when the fling
   ends. Back-to-top steps aside while the chat is lifted. WL.floats.place() re-runs the placement; WL.floats.moves counts.
   Calm placement (14 Oct 2026, owner 13 Oct: "fix the live chat icon", "phone is the most important"; QA of the first fix:
   a slow scroll that paused every 100 px moved the launcher 20 to 25 times per Kids Play page at 360 and 390, up over each
   card button and straight back down, and 216 px up at 768 behind a wrapped title): the launcher keeps whatever place it
   has, home or lifted, while that place is clear (hysteresis), so it no longer drops home after every card. When it has to
   move it goes to the other of two places: home, or one lane per page width taken from the card grid (the lift that clears
   a card button standing anywhere on the home spot: launcher + card button + 10 px, 110 px on the Kids Play phones; no
   lane where no card button reaches the launcher's column). Only when both are taken, the smallest clear lift (now 8 px
   clear of the obstacles instead of 10, so it fits the 74 px gap between a wrapped title and its button at 768); when
   none, home, fading only over a button, as before. Lifts are capped at 120 px from 600 px wide (tablets, desktop) and at 40% of
   the viewport on phones. A lifted launcher goes home once no obstacle is left in its column from half a screen above to
   a screen below (the cards are behind), so it does not stay lifted over the footer. It waits 400 ms without a scroll
   event, touchstart or touchend (and no finger down) before it moves, so a brief pause between two flicks never moves it,
   and it never moves during a scroll; one move is the same 0.25 s glide (none with reduced motion). WL.floats.lane gives the lane.
   Back to the calm placement (15 Oct 2026, same owner words; independent QA of the small-step version: a slow reader who
   paused over 3 s lost the chat about 27% of the time and it came back 110 px away): the small-step hold, the fade in place
   and the 3 s relocation are gone; the launcher is always shown (it fades only in the last-resort case above and over the
   avoid zones) and moves as in the calm placement, with the 400 ms wait (was 380) and never during a scroll. Only real
   controls are dodged now: [data-wl-g5-cta], [data-wl-dodge-float], buttons, button-styled links (class btn or button),
   fields and [role="button"] inside the dodge scope; plain text links (card titles, review counts, pills) are not, the
   whole card is a link anyway, so a title or a review line under the launcher no longer moves it. WL.floats.fades counts
   the last-resort fades. */
(function () {
  try {
    var html = document.documentElement;
    var BAR_SEL = '#cart-bar, #fpc-sticky, [data-wl-bottom-bar]';
    var CONSENT_SEL = '#shopify-pc__banner';
    var WL_TEASER = 'kl-teaser-';
    var BTT_SEL = '[data-scroll-top-button]';
    var FORM_CTRL = function (f) { return f + ' input:not([type="hidden"]), ' + f + ' select, ' + f + ' textarea, ' + f + ' button'; };
    var AVOID_SEL = '[data-wl-avoid-float], ' + FORM_CTRL('form#family-quote-form') + ', ' + FORM_CTRL('form#fpc-quote-form') + ', [data-cart-page] .cart__aside .cart-block';
    var hiddenByUs = false, queued = false, needTag = true, last = {}, settleT = [], pollT = 0, flagAt = 0, flagLift = 0, holdT = 0;
    var TPL = (window.WL && window.WL.tpl) || '', DODGE_HARD = '[data-wl-g5-cta], [data-wl-dodge-float]';
    var DODGE_SCOPE = TPL === 'index' || TPL === 'collection' ? 'main, .product-item' : '.product-item, .index-products';
    var DODGE_CTRL = 'a[href], button, input:not([type="hidden"]), select, textarea, [role="button"]', GAP = 8, MY = 2, IDLE = 400, WIDE_CAP = 120;
    var BTN_CLASS = /(^|\s|-)(btn|button)(\s|$|-)/;
    var dodge = 0, dodgeBlocked = false, moves = 0, fades = 0, scrolling = false, touching = false, interacted = false, idleT = 0, placeT = 0, initAt = 0, lastAct = 0;
    var shown = function (el) {
      if (!el || !el.isConnected) return false;
      var cs = getComputedStyle(el);
      if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) return false;
      var r = el.getBoundingClientRect();
      return r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < innerHeight && r.right > 0 && r.left < innerWidth;
    };
    var fadingOut = function (el) {
      try {
        var an = el.getAnimations ? el.getAnimations() : [];
        for (var i = 0; i < an.length; i++) {
          if (an[i].playState !== 'running') continue;
          var k = an[i].effect && an[i].effect.getKeyframes ? an[i].effect.getKeyframes() : [];
          if (k.length && k[k.length - 1].opacity !== undefined && parseFloat(k[k.length - 1].opacity) === 0) return true;
        }
      } catch (e) {}
      return false;
    };
    var barFlag = function (el) {
      if (el.id === 'cart-bar') return el.classList.contains('is-visible') || el.matches(':focus-within');
      if (el.id === 'fpc-sticky') return el.classList.contains('fpc-on');
      return el.classList.contains('is-visible') || el.getAttribute('data-wl-visible') === 'true';
    };
    var laidOut = function (el) {
      if (!el || !el.isConnected) return false;
      var cs = getComputedStyle(el);
      return cs.display !== 'none' && cs.visibility !== 'hidden' && el.offsetHeight > 0;
    };
    var barH = function (el) { return el.offsetHeight || Math.round(el.getBoundingClientRect().height); };
    var overlayOpen = function () {
      if (html.classList.contains('wl-pswp-open')) return true;
      if (document.querySelector('.drawer.is-open, dialog[open]')) return true;
      var m = document.querySelectorAll('[role="dialog"][aria-modal="true"], ' + CONSENT_SEL);
      for (var i = 0; i < m.length; i++) if (shown(m[i]) && !fadingOut(m[i])) return true;
      return false;
    };
    var tagTeaser = function () {
      var n = document.querySelectorAll('[class*="' + WL_TEASER + '"]');
      for (var i = 0; i < n.length; i++) {
        var el = n[i];
        if (el.classList.contains('wl-kl-teaser') || (el.parentElement && el.parentElement.closest('.wl-kl-teaser'))) continue;
        if (getComputedStyle(el).position === 'fixed') el.classList.add('wl-kl-teaser');
      }
    };
    var launcherEl = function () {
      var l = document.getElementById('wl-chat-launcher');
      if (l && !l.hidden) return l;
      return document.querySelector('.woot-widget-bubble');
    };
    var zoneHit = function (a, z) {
      for (var i = 0; i < z.length; i++) {
        var r = z[i].getBoundingClientRect();
        if (r.width && r.height && r.left < a.right && r.right > a.left && r.top < a.bottom && r.bottom > a.top) return true;
      }
      return false;
    };
    var yieldNow = function (z, lift) {
      var l = launcherEl(); if (!l) return false;
      var a = l.getBoundingClientRect(); if (!a.width) return false;
      if (zoneHit(a, z)) return true;
      // while the launcher glides to a new lift, also test where it is going, so it never slides over a zone visibly
      var d = (parseFloat(getComputedStyle(l).bottom) || 0) - (16 + lift + dodge);
      return Math.abs(d) >= 1 && zoneHit({ left: a.left, right: a.right, top: a.top + d, bottom: a.bottom + d }, z);
    };
    var restRect = function (el) {
      var r = el.getBoundingClientRect(), dx = 0, dy = 0;
      try { var t = getComputedStyle(el).transform; if (t && t !== 'none' && window.DOMMatrixReadOnly) { var m = new DOMMatrixReadOnly(t); dx = m.m41; dy = m.m42; } } catch (e) {}
      return { left: r.left - dx, right: r.right - dx, top: r.top - dy, bottom: r.bottom - dy, width: r.width, height: r.height };
    };
    var bttYield = function (z) {
      var b = document.querySelector(BTT_SEL);
      if (!b || getComputedStyle(b).display === 'none') return false;
      var a = restRect(b);
      return !!(a.width && a.height && zoneHit(a, z));
    };
    var teaserYield = function (z) {
      var t = document.querySelectorAll('.wl-kl-teaser');
      for (var i = 0; i < t.length; i++) {
        var a = t[i].getBoundingClientRect();
        if (a.width && a.height && zoneHit(a, z)) return true;
      }
      return false;
    };
    var set = function (cls, on) { if (last[cls] !== on) { last[cls] = on; html.classList.toggle(cls, on); } };
    // dodge (chat icon fix): where the launcher sits with no dodge, the obstacles in its column, the smallest clear lift
    var restOf = function (l, lift) {
      var r = l.getBoundingClientRect(), b = r.bottom + (parseFloat(getComputedStyle(l).bottom) || 0) - (16 + lift);
      return { left: r.left, right: r.right, top: b - r.height, bottom: b, width: r.width };
    };
    var up = function (r, d) { return { left: r.left, right: r.right, top: r.top - d, bottom: r.bottom - d }; };
    var hitAny = function (r, obs, my) {
      for (var i = 0; i < obs.length; i++) { var o = obs[i]; if (o.left < r.right && o.right > r.left && o.top < r.bottom + my && o.bottom > r.top - my) return true; }
      return false;
    };
    var obstacles = function (col, boxes) {
      var out = [], seen = [];
      var add = function (r, box) {
        if (r.width && r.height && r.left < col.right && r.right > col.left && r.top < col.bottom && r.bottom > col.top) { out.push(r); if (box) boxes.push(r); }
      };
      var off = function (e) {
        if (e.closest('summary, [hidden], [aria-hidden="true"], .visually-hidden, [data-wl-avoid-float]') || e.closest(AVOID_SEL)) return true;
        var cs = getComputedStyle(e); return cs.display === 'none' || cs.visibility === 'hidden' || !e.getClientRects().length;
      };
      var ctrl = function (e) {
        if (seen.indexOf(e) > -1) return;
        seen.push(e);
        // a plain text link is not a control to dodge (the whole card is a link); a button-styled link is
        if (e.tagName === 'A' && !e.matches(DODGE_HARD) && !e.matches('[role="button"]') && !BTN_CLASS.test(String(e.className))) return;
        if (!off(e)) add(e.getBoundingClientRect(), true);
      };
      var h = document.querySelectorAll(DODGE_HARD);
      for (var i = 0; i < h.length; i++) ctrl(h[i]);
      var sc = document.querySelectorAll(DODGE_SCOPE);
      for (var k = 0; k < sc.length; k++) {
        var s = sc[k].getBoundingClientRect();
        if (!(s.left < col.right && s.right > col.left && s.top < col.bottom && s.bottom > col.top)) continue;
        var c = sc[k].querySelectorAll(DODGE_CTRL);
        for (var m = 0; m < c.length; m++) ctrl(c[m]);
      }
      return out;
    };
    var chatOpen = function () { var w = document.querySelector('.woot-widget-holder'); return !!(w && !w.classList.contains('woot--hide')); };
    var applyDodge = function (d, blocked) {
      if (d === dodge && blocked === dodgeBlocked) return;
      var instant = d !== dodge && !interacted && Date.now() - initAt < 3000;
      if (instant) html.classList.add('wl-fl-instant');
      if (d !== dodge) moves++;
      if (blocked && !dodgeBlocked) fades++;
      dodge = d; dodgeBlocked = blocked;
      html.style.setProperty('--wl-float-dodge', d + 'px');
      set('wl-fl-dodged', d > 0);
      if (instant) { void html.offsetHeight; requestAnimationFrame(function () { requestAnimationFrame(function () { html.classList.remove('wl-fl-instant'); }); }); }
      if (window.WL && window.WL.floats) { window.WL.floats.dodge = d; window.WL.floats.moves = moves; window.WL.floats.lane = laneX; window.WL.floats.fades = fades; }
      schedule();
    };
    // one lane per page width: the lift that clears a card button standing anywhere on the home spot (0 = no lane)
    var laneW = -1, laneX = 0;
    var laneFor = function (rest, cap) {
      if (laneW !== innerWidth || !laneX) {
        var hs = document.querySelectorAll(DODGE_HARD), hmax = 0;
        for (var i = 0; i < hs.length; i++) {
          var r = hs[i].getBoundingClientRect();
          if (r.width && r.height && r.left < rest.right && r.right > rest.left && !hs[i].closest('[hidden], [aria-hidden="true"]')) hmax = Math.max(hmax, r.height);
        }
        laneW = innerWidth; laneX = hmax ? Math.ceil(rest.bottom - rest.top + MY + GAP + hmax) : 0;
      }
      return laneX && laneX <= cap ? laneX : 0;
    };
    var place = function () {
      placeT = 0;
      if (scrolling || touching || last['wl-overlay-open'] || chatOpen()) return;
      // never within IDLE of the last scroll event, touchstart or touchend (a finger lifted and put down again is a brief pause)
      var quiet = Date.now() - lastAct;
      if (quiet < IDLE) { queuePlace(IDLE - quiet + 5); return; }
      var l = launcherEl(); if (!l) return;
      var rest = restOf(l, last.lift || 0); if (!rest.width) return;
      var cap = Math.floor(Math.max(0, Math.min(innerHeight * 0.4, rest.top - 140, innerWidth >= 600 ? WIDE_CAP : 1e4)));
      var lane = laneFor(rest, cap);
      var boxes = [], col = { left: rest.left, right: rest.right, top: rest.top - cap - GAP, bottom: rest.bottom + GAP };
      var obs = obstacles(col, boxes);
      var all = obs.slice(), z = document.querySelectorAll(AVOID_SEL);
      for (var i = 0; i < z.length; i++) { var zr = z[i].getBoundingClientRect(); if (zr.width && zr.height) all.push(zr); }
      var homeFree = !hitAny(rest, obs, MY);
      // stay while the current place is clear (home or lifted); a lifted launcher goes home once the cards are behind
      if (dodge === 0 && homeFree) return applyDodge(0, false);
      if (dodge > 0 && dodge <= cap && !hitAny(up(rest, dodge), all, MY)) {
        if (homeFree && !obstacles({ left: rest.left, right: rest.right, top: -innerHeight / 2, bottom: innerHeight * 2 }, []).length) return applyDodge(0, false);
        return applyDodge(dodge, false);
      }
      // the other of the two places: home or the lane
      var order = lane ? (dodge === lane ? [0, lane] : [lane, 0]) : [0];
      for (var o = 0; o < order.length; o++) {
        var c = order[o]; if (c === dodge) continue;
        if (c === 0 ? homeFree : !hitAny(up(rest, c), all, GAP)) return applyDodge(c, false);
      }
      // the smallest clear lift within the cap; none: home, fading only when a button would be under it
      var cand = [];
      for (var j = 0; j < all.length; j++) { var d = Math.ceil(rest.bottom - all[j].top + GAP); if (d > 0 && d <= cap) cand.push(d); }
      cand.sort(function (a, b) { return a - b; });
      for (var k = 0; k < cand.length; k++) if (!hitAny(up(rest, cand[k]), all, GAP)) return applyDodge(cand[k], false);
      applyDodge(0, hitAny(rest, boxes, MY));
    };
    var queuePlace = function (ms) { clearTimeout(placeT); placeT = setTimeout(place, ms); };
    var onAnyScroll = function () {
      interacted = true; scrolling = true; lastAct = Date.now(); clearTimeout(placeT); clearTimeout(idleT);
      idleT = setTimeout(function () { scrolling = false; if (!touching) queuePlace(0); }, IDLE);
    };
    var update = function () {
      queued = false;
      if (needTag) { needTag = false; tagTeaser(); }
      var lift = 0, flag = 0, now = Date.now();
      var bars = document.querySelectorAll(BAR_SEL);
      for (var i = 0; i < bars.length; i++) {
        if (barFlag(bars[i]) && laidOut(bars[i])) flag = Math.max(flag, barH(bars[i]));
        else if (shown(bars[i])) lift = Math.max(lift, barH(bars[i]));
      }
      lift = Math.max(lift, flag);
      // a bar whose class goes off and on again within a few frames keeps the chat where it is (no jump)
      if (flag) { flagAt = now; flagLift = flag; }
      else if (lift < flagLift && now - flagAt < 250) { lift = flagLift; clearTimeout(holdT); holdT = setTimeout(schedule, 260 - (now - flagAt)); }
      if (last.lift !== lift) { last.lift = lift; html.style.setProperty('--wl-float-lift', lift + 'px'); if (!scrolling) queuePlace(120); }
      set('wl-chat-raised', lift > 0);
      var open = overlayOpen();
      if (last['wl-overlay-open'] && !open) queuePlace(150);
      set('wl-overlay-open', open);
      if (open && !pollT) poll();
      var zones = open ? [] : document.querySelectorAll(AVOID_SEL);
      set('wl-float-yield', !open && (dodgeBlocked || yieldNow(zones, lift)));
      set('wl-teaser-yield', !open && teaserYield(zones));
      set('wl-btt-yield', !open && bttYield(zones));
      set('wl-hide-desktop-teaser', !!(window.WL && window.WL.flags && window.WL.flags.hide_desktop_teaser));
      var cw = window.$chatwoot;
      if (cw && typeof cw.toggleBubbleVisibility === 'function') {
        if (open && !hiddenByUs) { cw.toggleBubbleVisibility('hide'); hiddenByUs = true; }
        else if (!open && hiddenByUs) { cw.toggleBubbleVisibility('show'); hiddenByUs = false; }
      }
    };
    var schedule = function () { if (!queued) { queued = true; requestAnimationFrame(update); } };
    var settle = function () {
      schedule();
      for (var i = 0; i < settleT.length; i++) clearTimeout(settleT[i]);
      settleT = [setTimeout(schedule, 150), setTimeout(schedule, 450), setTimeout(schedule, 900)];
    };
    var poll = function () {
      clearTimeout(pollT); pollT = 0;
      if (last['wl-overlay-open']) pollT = setTimeout(function () { schedule(); poll(); }, 300);
    };
    var onBodyChange = function () { needTag = true; settle(); if (!scrolling) queuePlace(500); };
    var init = function () {
      new MutationObserver(onBodyChange).observe(document.body, { childList: true, subtree: true });
      var mo = new MutationObserver(schedule);
      mo.observe(html, { attributes: true, attributeFilter: ['class'] });
      var watch = document.querySelectorAll(BAR_SEL + ', .drawer');
      for (var i = 0; i < watch.length; i++) mo.observe(watch[i], { attributes: true, attributeFilter: ['class', 'open', 'data-wl-visible', 'style'] });
      ['theme:scroll:lock', 'theme:scroll:unlock', 'theme:cart-drawer:open', 'theme:cart-drawer:close', 'visitorConsentCollected'].forEach(function (ev) {
        document.addEventListener(ev, function () { requestAnimationFrame(schedule); });
      });
      ['animationstart', 'animationend', 'animationcancel', 'transitionend', 'transitioncancel', 'focusin', 'focusout'].forEach(function (ev) {
        document.addEventListener(ev, schedule, true);
      });
      window.addEventListener('chatwoot:ready', schedule);
      window.addEventListener('resize', schedule, { passive: true });
      window.addEventListener('scroll', schedule, { passive: true });
      // dodge: placed only when scrolling (window or a horizontal row) has stopped and no finger is down
      var cap = { capture: true, passive: true };
      document.addEventListener('scroll', onAnyScroll, cap);
      document.addEventListener('touchstart', function () { touching = true; interacted = true; lastAct = Date.now(); clearTimeout(placeT); }, cap);
      ['touchend', 'touchcancel'].forEach(function (ev) {
        document.addEventListener(ev, function (e) { touching = !!(e.touches && e.touches.length); lastAct = Date.now(); if (!touching && !scrolling) queuePlace(IDLE); }, cap);
      });
      ['animationend', 'transitionend'].forEach(function (ev) {
        document.addEventListener(ev, function (e) { if (!scrolling && !touching && e.target !== launcherEl()) queuePlace(150); }, true);
      });
      window.addEventListener('resize', function () { queuePlace(200); }, { passive: true });
      window.addEventListener('load', function () { queuePlace(100); });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { queuePlace(100); });
      window.addEventListener('chatwoot:ready', function () { queuePlace(300); });
      initAt = Date.now();
      schedule();
      queuePlace(0);
    };
    if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
    window.WL = window.WL || {};
    window.WL.floats = { update: update, place: place, dodge: 0, moves: 0, lane: 0, fades: 0 };
  } catch (e) {}
})();

/* R19 top bar, calm version (16 Oct 2026; owner: "the header still looks like shit, pergolux has a clean header, ours is
   overfilled with unnecessary texts"). One message at a time at every width (markup: snippets/wl-topbar.liquid):
   4.5 s per message, three rounds, then it rests on the first; a tap, click or keyboard focus in the bar stops it for
   good; it pauses under the mouse and in a hidden tab; no rotation with reduced motion or with one message (Family Play
   pages). A message wider than its box gets slightly tighter letter spacing (is-tight) and, as a last resort, an ellipsis
   in CSS. This replaces the phone rotation, the tablet driver that lived in the snippet and the desktop fit routine.
   WL.topbar.show(i) and WL.topbar.stop() for QA. */
(function () {
  try {
    var bar = document.querySelector('[data-wl-topbar]'); if (!bar) return;
    var list = bar.querySelector('[data-wl-tb-list]'); if (!list) return;
    var mqR = matchMedia('(prefers-reduced-motion: reduce)');
    var timer = 0, idx = 0, steps = 0, stopped = false, paused = false, raf = 0;
    var items = function () { return [].slice.call(list.children); };
    var guard = function () {
      raf = 0;
      bar.classList.remove('is-tight');
      var a = list.querySelector('.is-active > a');
      if (a && a.scrollWidth > a.clientWidth + 1) bar.classList.add('is-tight');
    };
    var refit = function () { if (!raf) raf = requestAnimationFrame(guard); };
    var show = function (i) {
      var its = items(); if (!its.length) return;
      idx = ((i % its.length) + its.length) % its.length;
      its.forEach(function (li, k) { li.classList.toggle('is-active', k === idx); });
      guard();
    };
    var tick = function () {
      if (paused || document.hidden) return;
      steps++;
      if (steps >= items().length * 3) { stopped = true; clearInterval(timer); timer = 0; show(0); return; }
      show(idx + 1);
    };
    var start = function () {
      clearInterval(timer); timer = 0;
      if (stopped) return;
      if (mqR.matches || items().length < 2) { show(0); return; }
      timer = setInterval(tick, 4500);
    };
    var userStop = function () { if (stopped) return; stopped = true; clearInterval(timer); timer = 0; };
    bar.addEventListener('touchstart', userStop, { passive: true });
    bar.addEventListener('click', userStop);
    bar.addEventListener('focusin', userStop);
    bar.addEventListener('mouseenter', function () { paused = true; });
    bar.addEventListener('mouseleave', function () { paused = false; });
    var init = function () {
      show(0); start();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(refit);
      window.addEventListener('resize', refit, { passive: true });
      if (mqR.addEventListener) mqR.addEventListener('change', start); else if (mqR.addListener) mqR.addListener(start);
    };
    if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
    window.WL = window.WL || {};
    window.WL.topbar = { show: show, stop: userStop };
  } catch (e) {}
})();
